/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The decision.
 */
export const RiskPolicyApprovalDecisionRequestBodyDecision = {
  Approve: "approve",
  Deny: "deny",
} as const;
/**
 * The decision.
 */
export type RiskPolicyApprovalDecisionRequestBodyDecision = ClosedEnum<
  typeof RiskPolicyApprovalDecisionRequestBodyDecision
>;

export type RiskPolicyApprovalDecisionRequestBody = {
  /**
   * The decision.
   */
  decision: RiskPolicyApprovalDecisionRequestBodyDecision;
  /**
   * The approval request ID.
   */
  id: string;
  /**
   * Optional message for the agent.
   */
  note?: string | undefined;
};

/** @internal */
export const RiskPolicyApprovalDecisionRequestBodyDecision$outboundSchema:
  z.ZodMiniEnum<typeof RiskPolicyApprovalDecisionRequestBodyDecision> = z.enum(
    RiskPolicyApprovalDecisionRequestBodyDecision,
  );

/** @internal */
export type RiskPolicyApprovalDecisionRequestBody$Outbound = {
  decision: string;
  id: string;
  note?: string | undefined;
};

/** @internal */
export const RiskPolicyApprovalDecisionRequestBody$outboundSchema:
  z.ZodMiniType<
    RiskPolicyApprovalDecisionRequestBody$Outbound,
    RiskPolicyApprovalDecisionRequestBody
  > = z.object({
    decision: RiskPolicyApprovalDecisionRequestBodyDecision$outboundSchema,
    id: z.string(),
    note: z.optional(z.string()),
  });

export function riskPolicyApprovalDecisionRequestBodyToJSON(
  riskPolicyApprovalDecisionRequestBody: RiskPolicyApprovalDecisionRequestBody,
): string {
  return JSON.stringify(
    RiskPolicyApprovalDecisionRequestBody$outboundSchema.parse(
      riskPolicyApprovalDecisionRequestBody,
    ),
  );
}
